import AccountingSystem from "./AccountingSystem";

export interface BalanceSheetData {
    asset: string | null;
    assetRow: string | null;
    assetEndBalance: string | null;
    assetInitBalance: string | null;
    assetText: string | null;
    equity?: string | null;
    equityRow: string | null;
    equityEndBalance: string | null;
    equityInitBalance: string | null;
    equityText?: string | null;
    id: string;
    fold: null | string;
    foldFlag: null;
    assistantNo?: null
}

const npo: BalanceSheetData[] = [
    {
        "asset": "流动资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "流动负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "1",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "货币资金",
        "assetRow": "1",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "短期借款",
        "equityRow": "61",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "2",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "短期投资",
        "assetRow": "2",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付款项",
        "equityRow": "62",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "3",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "应收款项",
        "assetRow": "3",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付工资",
        "equityRow": "63",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "4",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "预付账款",
        "assetRow": "4",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应交税金",
        "equityRow": "65",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "5",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "存  货",
        "assetRow": "8",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "预收账款",
        "equityRow": "66",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "6",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "待摊费用",
        "assetRow": "9",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "预提费用",
        "equityRow": "71",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "7",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "一年内到期的长期债权投资",
        "assetRow": "15",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "预计负债",
        "equityRow": "72",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "8",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "其他流动资产",
        "assetRow": "18",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "一年内到期的长期负债",
        "equityRow": "74",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "9",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "流动资产合计",
        "assetRow": "20",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其他流动负债",
        "equityRow": "78",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "10",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": null,
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "流动负债合计",
        "equityRow": "80",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "11",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "长期投资：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "12",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "长期股权投资",
        "assetRow": "21",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "13",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "长期债权投资",
        "assetRow": "24",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期借款",
        "equityRow": "81",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "14",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "长期投资合计",
        "assetRow": "30",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期应付款",
        "equityRow": "84",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "15",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": null,
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "其他长期负债",
        "equityRow": "88",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "16",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "固定资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "长期负债合计",
        "equityRow": "90",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "17",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "固定资产原价",
        "assetRow": "31",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "18",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "减：累计折旧",
        "assetRow": "32",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "受托代理负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "19",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "固定资产净值",
        "assetRow": "33",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "受托代理负债",
        "equityRow": "91",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "20",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "在建工程",
        "assetRow": "34",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "21",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "文物文化资产",
        "assetRow": "35",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债合计",
        "equityRow": "100",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "22",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "固定资产清理",
        "assetRow": "38",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "23",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "固定资产合计",
        "assetRow": "40",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "24",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": null,
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "净资产：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "25",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "无形资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "非限定性净资产",
        "equityRow": "101",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "26",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "无形资产",
        "assetRow": "41",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "限定性净资产",
        "equityRow": "105",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "27",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": null,
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "净资产合计",
        "equityRow": "110",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "28",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "受托代理资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "29",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "受托代理资产",
        "assetRow": "51",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "30",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": null,
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "31",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "资产总计",
        "assetRow": "60",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债和净资产总计",
        "equityRow": "120",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "32",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }
];

const sevenRule: BalanceSheetData[] = [
    {
        asset: "流动资产：",
        assetRow: "",
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "流动负债：",
        equityRow: "",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "1",
        fold: null,
        foldFlag: null
    },
    {
        asset: "货币资金",
        assetRow: "1",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "库存现金+银行存款+其他货币资金",
        equity: "短期借款",
        equityRow: "30",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "短期借款",
        id: "2",
        fold: null,
        foldFlag: null
    },
    {
        asset: "以公允价值计量且其变动计入当期损益的金融资产",
        assetRow: "2",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: null,
        equity: "以公允价值计量且其变动计入当期损益的金融负债",
        equityRow: "31",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: null,
        id: "2-1",
        fold: null,
        foldFlag: null
    },
    {
        asset: "衍生金融资产",
        assetRow: "3",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: null,
        equity: "衍生金融负债",
        equityRow: "32",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: null,
        id: "3",
        fold: null,
        foldFlag: null
    },
    {
        asset: "应收票据",
        assetRow: "4",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "应收票据",
        equity: "应付票据",
        equityRow: "33",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "应付票据",
        id: "4",
        fold: null,
        foldFlag: null
    },
    {
        asset: "应收账款",
        assetRow: "5",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "应收账款明细借方-坏账准备+预收账款明细借方",
        equity: "应付账款",
        equityRow: "34",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "预付账款明细贷方+应付账款明细贷方",
        id: "5",
        fold: null,
        foldFlag: null
    },
    {
        asset: "预付款项",
        assetRow: "6",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "预付账款明细借方+应付账款明细借方",
        equity: "预收款项",
        equityRow: "35",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "应收账款明细贷方+预收账款明细贷方-工程施工+工程结算",
        id: "6",
        fold: null,
        foldFlag: null
    },
    {
        asset: "其他应收款",
        assetRow: "7",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "其他应收款明细借方+其他应付款明细借方+应收利息+应收股利",
        equity: "应付职工薪酬",
        equityRow: "36",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "应付职工薪酬",
        id: "7",
        fold: null,
        foldFlag: null
    },
    {
        asset: "存货",
        assetRow: "8",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText:"受托代销商品+材料采购+在途物资+原材料+材料成本差异+库存商品+发出商品-商品进销差价+委托加工物资+周转材料+消耗性生物资产+融资租赁资产-存货跌价准备-受托代销商品款+生产成本+制造费用+劳务成本+工程施工-工程结算+机械作业",
        equity: "应交税费",
        equityRow: "37",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText:
            "未交增值税贷方余额 + 简易计税贷方余额 + 转让金融商品应交增值税贷方余额 + 代扣代交增值税贷方余额 + 应交增值税贷方余额 + 预交增值税贷方余额 + 待抵扣进项税额贷方余额 + 待认证进项税额贷方余额 + 增值税留抵税额贷方余额 + 应交税费其余下级科目（待转销项税额除外）的余额",
        id: "8",
        fold: null,
        foldFlag: null
    },
    {
        asset: "持有待售资产",
        assetRow: "9",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "应收出口退税款其他应收款+应收利息+应收股利",
        equity: "其他应付款",
        equityRow: "38",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "其他应付款明细贷方+其他应收款明细贷方+应付利息+应付股利",
        id: "9",
        fold: null,
        foldFlag: null
    },

    {
        // asset: "其他流动资产",
        asset: "一年内到期的非流动资产",
        assetRow: "10",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: null,
        // equity: "一年内到期的非流动负债",
        equity: "持有待售负债",
        equityRow: "39",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "10",
        fold: null,
        foldFlag: null
    },
    {
        asset: "其他流动资产",
        assetRow: "11",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: null,
        equity: "一年内到期的非流动负债",
        equityRow: "40",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "1311",
        fold: null,
        foldFlag: null
    },
    {
        asset: "流动资产合计",
        assetRow: "12",
        assetEndBalance: "-10.00",
        assetInitBalance: "0",
        // assetText: "行2+行3+行4+行5+行6+行7+行8+行9+行10+行11+行12",
        assetText: "1至11行合计",
        equity: "其他流动负债",
        equityRow: "41",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: "其他流动负债",
        id: "12",
        fold: null,
        foldFlag: null
    },
    {
        asset: "非流动资产：",
        assetRow: "",
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "流动负债合计",
        equityRow: "42",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "30至41行合计",
        id: "14-1",
        fold: null,
        foldFlag: null
    },
    {
        asset: "可供出售金融资产",
        assetRow: "13",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "可供出售金融资产",
        equity: "非流动负债：",
        equityRow: "",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "13",
        fold: null,
        foldFlag: null
    },
    {
        asset: "持有至到期投资",
        assetRow: "14",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "持有至到期投资-持有至到期投资减值准备",
        equity: "长期借款",
        equityRow: "43",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "长期借款",
        id: "14",
        fold: null,
        foldFlag: null
    },
    {
        asset: "长期应收款",
        assetRow: "15",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "长期应收款-未实现融资收益",
        equity: "应付债券",
        equityRow: "44",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "应付债券",
        id: "15",
        fold: null,
        foldFlag: null
    },
    {
        asset: "长期股权投资",
        assetRow: "16",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "其中：优先股",
        equity: "其中：优先股",
        equityRow: "45",
        equityEndBalance: "0",
        equityInitBalance: "0",
        // equityText: "长期应付款-未确认融资费用",
        equityText: null,
        id: "16",
        fold: null,
        foldFlag: null
    },
    {
        asset: "投资性房地产",
        assetRow: "17",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "投资性房地产",
        // equity: "专项应付款",
        equity: "永续债",
        equityRow: "46",
        equityEndBalance: "0",
        equityInitBalance: "0",
        // equityText: "专项应付款",
        equityText: null,
        id: "17",
        fold: null,
        foldFlag: null
    },
    {
        asset: "固定资产",
        assetRow: "18",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "固定资产项目的公式改为固定资产-累计折旧-固定资产减值准备+固定资产清理",
        // equity: "预计负债",
        equity: "长期应付款",
        equityRow: "47",
        equityEndBalance: "0",
        equityInitBalance: "0",
        // equityText: "预计负债",
        equityText: "长期应付款-未确认融资费用+专项应付款",
        id: "18",
        fold: null,
        foldFlag: null
    },
    {
        asset: "在建工程",
        assetRow: "19",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "在建工程+工程物资",
        // equity: "递延所得税负债",
        equity: "预计负债",
        equityRow: "48",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "预计负债",
        id: "19",
        fold: null,
        foldFlag: null
    },
    {
        asset: "生产性生物资产",
        assetRow: "20",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "生产性生物资产-生产性生物资产累计折旧",
        equity: "递延收益",
        equityRow: "49",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "递延收益",
        id: "20",
        fold: null,
        foldFlag: null
    },
    {
        asset: "油气资产",
        assetRow: "21",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "油气资产",
        equity: "递延所得税负债",
        equityRow: "50",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "",
        id: "21",
        fold: null,
        foldFlag: null
    },
    {
        asset: "无形资产",
        assetRow: "22",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "无形资产-累计摊销-无形资产减值准备",
        equity: "其他非流动负债",
        equityRow: "51",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: null,
        id: "22",
        fold: null,
        foldFlag: null
    },
    {
        asset: "开发支出",
        assetRow: "23",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "研发支出",
        equity: "非流动负债合计",
        equityRow: "52",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: "43+44+47+48+49+50+51",
        id: "23",
        fold: null,
        foldFlag: null
    },
    {
        asset: "商誉",
        assetRow: "24",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "商誉",
        equity: "负债合计",
        equityRow: "53",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "负债合计",
        id: "24",
        fold: null,
        foldFlag: null
    },
    
    {
        asset: "长期待摊费用",
        assetRow: "25",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "长期待摊费用",
        equity: "所有者权益(或股东权益):",
        equityRow: "",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: "所有者权益(或股东权益):",
        id: "25",
        fold: null,
        foldFlag: null
    },
    
    {
        asset: "递延所得税资产",
        assetRow: "26",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "递延所得税资产",
        equity: "实收资本(或股本)",
        equityRow: "54",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: null,
        id: "26",
        fold: null,
        foldFlag: null
    },
    
    {
        asset: "其他非流动资产",
        assetRow: "27",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText: "公益性生物资产+待处理非流动资产损溢+独立账户资产",
        equity: "其他权益工具",
        equityRow: "55",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: null,
        id: "27",
        fold: null,
        foldFlag: null
    },
    
    {
        asset: "非流动资产合计",
        assetRow: "28",
        assetEndBalance: "0",
        assetInitBalance: "0",
        assetText:
            "13至27行合计",
        equity: "其中：优先股",
        equityRow: "56",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "28",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "永续债",
        equityRow: "57",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "29",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "资本公积",
        equityRow: "58",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "30",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "减：库存股",
        equityRow: "59",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "31",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "其他综合收益",
        equityRow: "60",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "32",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "专项储备",
        equityRow: "61",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "33",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "盈余公积",
        equityRow: "62",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "34",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "未分配利润",
        equityRow: "63",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "35",
        fold: null,
        foldFlag: null
    },
    {
        asset: null,
        assetRow: null,
        assetEndBalance: null,
        assetInitBalance: null,
        assetText: null,
        equity: "所有者权益(或股东权益)合计",
        equityRow: "64",
        equityEndBalance: null,
        equityInitBalance: null,
        equityText: null,
        id: "36",
        fold: null,
        foldFlag: null
    },

    {
        asset: "资产总计",
        assetRow: "29",
        assetEndBalance: "-10.00",
        assetInitBalance: "0",
        assetText: null,
        equity: "负债和所有者权益（或股东权益）总计",
        equityRow: "65",
        equityEndBalance: "0",
        equityInitBalance: "0",
        equityText: null,
        id: "37",
        fold: null,
        foldFlag: null
    }
];

const thirteenRule: BalanceSheetData[] = [
    {
        "asset": "流动资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "流动负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "1",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "货币资金",
        "assetRow": "1",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "短期借款",
        "equityRow": "31",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "2",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：库存现金+银行存款+其他货币资金",
        "equityText": "科目：短期借款",
    }, {
        "asset": "短期投资",
        "assetRow": "2",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付票据",
        "equityRow": "32",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "3",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：短期投资",
        "equityText": "科目：应付票据",
    }, {
        "asset": "应收票据",
        "assetRow": "3",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付账款",
        "equityRow": "33",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "4",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：应收票据",
        "equityText": "科目：应付账款+预付账款",
    }, {
        "asset": "应收账款",
        "assetRow": "4",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "预收账款",
        "equityRow": "34",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "5",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：应收账款+预收账款",
        "equityText": "科目：应收账款+预收账款",
    }, {
        "asset": "预付账款",
        "assetRow": "5",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付职工薪酬",
        "equityRow": "35",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "6",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：预付账款+应付账款",
        "equityText": "科目：应付职工薪酬",
    }, {
        "asset": "应收股利",
        "assetRow": "6",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应交税费",
        "equityRow": "36",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "7",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：应收股利",
        "equityText": "科目：应交税费",
    }, {
        "asset": "应收利息",
        "assetRow": "7",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付利息",
        "equityRow": "37",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "8",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：应收利息",
        "equityText": "科目：应付利息",
    }, {
        "asset": "其他应收款",
        "assetRow": "8",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付利润",
        "equityRow": "38",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "9",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：其他应收款",
        "equityText": "科目：应付利润",
    }, {
        "asset": "存货",
        "assetRow": "9",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其他应付款",
        "equityRow": "39",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "10",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：材料采购 + 在途物资 +原材料 + 材料成本差异 + 库存商品 - 商品进销差价 + 委托加工物资 + 周转材料 + 消耗性生物资产 +生产成本 + 劳务成本 + 制造费用 + 工程施工 + 机械作业",
        "assistantNo": null
    }, {
        "asset": "其中：原材料",
        "assetRow": "10",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其他流动负债",
        "equityRow": "40",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "11",
        "fold": "10",
        "foldFlag": null,
        "assetText": "科目：原材料",
        "equityText": null,
    }, {
        "asset": "在产品",
        "assetRow": "11",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "流动负债合计",
        "equityRow": "41",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "12",
        "fold": "10",
        "foldFlag": null,
        "assetText": "科目：生产成本 + 劳务成本 + 制造费用  + 工程施工 + 机械作业",
        "equityText": "行次：行31+行32+行33+行34+行35+行36+行37+行38+行39+行40",
    }, {
        "asset": "库存商品",
        "assetRow": "12",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "非流动负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "13",
        "fold": "10",
        "foldFlag": null,
        "assetText": "科目：库存商品",
        "equityText": null,
    }, {
        "asset": "周转材料",
        "assetRow": "13",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期借款",
        "equityRow": "42",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "14",
        "fold": "10",
        "foldFlag": null,
        "assetText": "科目：周转材料",
        "equityText": "科目：长期借款",
    }, {
        "asset": "其他流动资产",
        "assetRow": "14",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期应付款",
        "equityRow": "43",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "15",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：待处理流动资产损益",
        "equityText": "科目：长期应付款",
    }, {
        "asset": "流动资产合计",
        "assetRow": "15",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "递延收益",
        "equityRow": "44",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "16",
        "fold": null,
        "foldFlag": null,
        "assetText": "行次：行1+行2+行3+行4+行5+行6+行7+行8+行9+行14",
        "equityText": "科目：递延收益",
    }, {
        "asset": "非流动资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "其他非流动负债",
        "equityRow": "45",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "17",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "长期债券投资",
        "assetRow": "16",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "非流动负债合计",
        "equityRow": "46",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "18",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：长期债券投资",
        "equityText": "行次：行42+行43+行44+行45",
    }, {
        "asset": "长期股权投资",
        "assetRow": "17",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债合计",
        "equityRow": "47",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "19",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：长期股权投资",
        "equityText": "行次：行41+行46",
    }, {
        "asset": "固定资产原价",
        "assetRow": "18",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "20",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：固定资产",
        "equityText": null,
    }, {
        "asset": "减：累计折旧",
        "assetRow": "19",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "21",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：累计折旧",
        "equityText": null,
    }, {
        "asset": "固定资产账面价值",
        "assetRow": "20",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "22",
        "fold": null,
        "foldFlag": null,
        "assetText": "行次：行18-行19",
        "equityText": null,
    }, {
        "asset": "在建工程",
        "assetRow": "21",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "23",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：在建工程",
        "equityText": null,
    }, {
        "asset": "工程物资",
        "assetRow": "22",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "24",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：工程物资",
        "equityText": null,
    }, {
        "asset": "固定资产清理",
        "assetRow": "23",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": null,
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "25",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：固定资产清理",
        "equityText": null,
    }, {
        "asset": "生产性生物资产",
        "assetRow": "24",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "所有者权益（或股东权益）：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "26",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：生产性生物资产-生产性生物资产累计折旧",
        "equityText": null,
    }, {
        "asset": "无形资产",
        "assetRow": "25",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "实收资本（或股本）",
        "equityRow": "48",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "27",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：无形资产-累计摊销",
        "equityText": "科目：实收资本",
    }, {
        "asset": "开发支出",
        "assetRow": "26",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "资本公积",
        "equityRow": "49",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "28",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：研发支出",
        "equityText": "科目：资本公积",
    }, {
        "asset": "长期待摊费用",
        "assetRow": "27",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "盈余公积",
        "equityRow": "50",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "29",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：长期待摊费用",
        "equityText": "科目：盈余公积",
    }, {
        "asset": "其他非流动资产",
        "assetRow": "28",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "未分配利润",
        "equityRow": "51",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "30",
        "fold": null,
        "foldFlag": null,
        "assetText": "科目：待处理非流动资产损益",
        "equityText": "科目：利润分配+本年利润",
    }, {
        "asset": "非流动资产合计",
        "assetRow": "29",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "所有者权益（或股东权益）合计",
        "equityRow": "52",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "31",
        "fold": null,
        "foldFlag": null,
        "assetText": "行次：行16+行17+行20+行21+行22+行23+行24+行25+行26+行27+行28",
        "equityText": "行次：行48+行49+行50+行51",
    }, {
        "asset": "资产总计",
        "assetRow": "30",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债和所有者权益（或股东权益）总计",
        "equityRow": "53",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "32",
        "fold": null,
        "foldFlag": null,
        "assetText": "行次：行15+行29",
        "equityText": "行次：行47+行52",
    }
];

const rural: BalanceSheetData[] = [
    {
        "asset": "流动资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "流动负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "1",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "货币资金",
        "assetRow": "1",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "短期借款",
        "equityRow": "17",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "2",
        "fold": null,
        "foldFlag": null,
        "assetText": "现金+银行存款",
        "equityText": "短期借款",
    }, {
        "asset": "短期投资",
        "assetRow": "2",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付款项",
        "equityRow": "18",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "3",
        "fold": null,
        "foldFlag": null,
        "assetText": "短期投资",
        "equityText": "应付款",
    }, {
        "asset": "应收款项",
        "assetRow": "3",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付工资",
        "equityRow": "19",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "4",
        "fold": null,
        "foldFlag": null,
        "assetText": "应收款",
        "equityText": "应付工资",
    }, {
        "asset": "存货",
        "assetRow": "4",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付福利费",
        "equityRow": "20",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "5",
        "fold": null,
        "foldFlag": null,
        "assetText": "生产（劳务）成本+库存物资",
        "equityText": "应付福利费",
    }, {
        "asset": "流动资产合计",
        "assetRow": "5",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "流动负债合计",
        "equityRow": "21",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "6",
        "fold": null,
        "foldFlag": null,
        "assetText": "1+2+3+4",
        "equityText": "17+18+19+20",
    },
    {
        "asset": "农业资产：",
        "assetRow": "",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "长期负债：",
        "equityRow": "",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "8",
        "fold": null,
        "foldFlag": null,
        "assetText": "",
        "equityText": "",
    },
    {
        "asset": "牲畜（禽）资产",
        "assetRow": "6",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期借款及应付款",
        "equityRow": "36",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "9",
        "fold": null,
        "foldFlag": null,
        "assetText": "牲畜（禽）资产",
        "equityText": "长期借款及应付款",
    }, {
        "asset": "林木资产",
        "assetRow": "7",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "一事一议资金",
        "equityRow": "23",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "10",
        "fold": null,
        "foldFlag": null,
        "assetText": "林木资产",
        "equityText": "一事一议资金",
    }, {
        "asset": "",
        "assetRow": "",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "专项应付款",
        "equityRow": "24",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "11",
        "fold": null,
        "foldFlag": null,
        "assetText": "",
        "equityText": "",
    }, {
        "asset": "",
        "assetRow": "",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "其中：征地补偿费",
        "equityRow": "25",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "12",
        "fold": null,
        "foldFlag": null,
        "assetText": "",
        "assistantNo": null
    }, {
        "asset": "农业资产合计",
        "assetRow": "8",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期负债合计",
        "equityRow": "26",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "13",
        "fold": "10",
        "foldFlag": null,
        "assetText": "6+7",
        "equityText": "22+23+24",
    }, {
        "asset": "长期资产：",
        "assetRow": "",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "负债合计",
        "equityRow": "27",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "14",
        "fold": "10",
        "foldFlag": null,
        "assetText": "",
        "equityText": "21+26",
    }, {
        "asset": "长期投资",
        "assetRow": "9",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "15",
        "fold": "10",
        "foldFlag": null,
        "assetText": "长期投资",
        "equityText": null,
    }, {
        "asset": "固定资产：",
        "assetRow": "",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "",
        "equityRow": "",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "16",
        "fold": "10",
        "foldFlag": null,
        "assetText": "",
        "equityText": "",
    }, {
        "asset": "固定资产原价：",
        "assetRow": "10",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "",
        "equityRow": "",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "17",
        "fold": null,
        "foldFlag": null,
        "assetText": "固定资产",
        "equityText": "",
    }, {
        "asset": "减：累计折旧",
        "assetRow": "11",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "所有者权益：",
        "equityRow": "",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "18",
        "fold": null,
        "foldFlag": null,
        "assetText": "累计折旧 贷方正数，借方负数",
        "equityText": "",
    }, {
        "asset": "固定资产净值",
        "assetRow": "12",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "资本",
        "equityRow": "28",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "19",
        "fold": null,
        "foldFlag": null,
        "assetText": "10-11",
        "equityText": "资本",
    }, {
        "asset": "固定资产清理",
        "assetRow": "13",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "公积公益金",
        "equityRow": "29",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "20",
        "fold": null,
        "foldFlag": null,
        "assetText": "固定资产清理",
        "equityText": "公积公益金",
    }, {
        "asset": "在建工程",
        "assetRow": "14",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "未分配收益",
        "equityRow": "30",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "21",
        "fold": null,
        "foldFlag": null,
        "assetText": "在建工程",
        "equityText": "未分配收益",
    }, {
        "asset": "固定资产合计",
        "assetRow": "15",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "所有权益合计",
        "equityRow": "31",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "22",
        "fold": null,
        "foldFlag": null,
        "assetText": "固定资产合计",
        "equityText": "28+29+30",
    }, {
        "asset": "资产总计",
        "assetRow": "16",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债和所有者权益合计",
        "equityRow": "32",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "23",
        "fold": null,
        "foldFlag": null,
        "assetText": "5+8+9+15",
        "equityText": "27+31",
    },
];

const nineteenRule: BalanceSheetData[] = [
    {
        "asset": "流动资产：",
        "assetRow": null,
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "流动负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "1",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "货币资金",
        "assetRow": "1",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "短期借款",
        "equityRow": "35",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "2",
        "fold": null,
        "foldFlag": null,
        "assetText": "（库存现金+银行存款+其他货币资金）余额",
        "equityText": "短期借款余额",
    }, {
        "asset": "交易性金融资产",
        "assetRow": "2",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "交易性金融负债",
        "equityRow": "36",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "3",
        "fold": null,
        "foldFlag": null,
        "assetText": "交易性金融资产余额",
        "equityText": "交易性金融负责余额",
    }, {
        "asset": "衍生金融资产",
        "assetRow": "3",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "衍生金融负债",
        "equityRow": "37",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "4",
        "fold": null,
        "foldFlag": null,
        "assetText": "衍生工具借方余额",
        "equityText": "衍生工具贷方余额",
    }, {
        "asset": "应收票据",
        "assetRow": "4",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付票据",
        "equityRow": "38",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "5",
        "fold": null,
        "foldFlag": null,
        "assetText": "应收票据余额",
        "equityText": "应付票据余额",
    }, {
        "asset": "应收账款",
        "assetRow": "5",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付账款",
        "equityRow": "39",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "6",
        "fold": null,
        "foldFlag": null,
        "assetText": "应收账款余额",
        "equityText": "应负账款余额",
    },
    {
        "asset": "应收款项融资",
        "assetRow": "6",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "预收款项",
        "equityRow": "40",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "8",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": "预收账款余额",
    },
    {
        "asset": "预付款项",
        "assetRow": "7",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "合同负债",
        "equityRow": "41",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "9",
        "fold": null,
        "foldFlag": null,
        "assetText": "预付账款余额",
        "equityText": "合同负债余额+合同结算明细贷方余额",
    }, {
        "asset": "其他应收款",
        "assetRow": "8",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付职工薪酬",
        "equityRow": "42",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "10",
        "fold": null,
        "foldFlag": null,
        "assetText": "其他应收款余额",
        "equityText": "应付职工薪酬余额",
    }, {
        "asset": "存货",
        "assetRow": "9",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "应交税费",
        "equityRow": "43",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "11",
        "fold": null,
        "foldFlag": null,
        "assetText": "（存货跌价准备+劳务成本+制造费用+原材料+材料采购+库存商品+在途物资+周转材料+商品进销差价+生产成本+委托加工物资+发出商品+受托代销商品+应收退货成本+材料成本差异）余额",
        "equityText": "未交增值税贷方余额 + 简易计税贷方余额 + 转让金融商品应交增值税贷方余额 + 代扣代交增值税贷方余额 + 应交增值税贷方余额 + 预交增值税贷方余额 + 待抵扣进项税额贷方余额 + 待认证进项税额贷方余额 + 增值税留抵税额贷方余额 + 应交税费其余下级科目（待转销项税额除外）的余额",
    }, {
        "asset": "合同资产",
        "assetRow": "10",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "其他应付款",
        "equityRow": "44",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "12",
        "fold": null,
        "foldFlag": null,
        "assetText": "（合同取得成本减值准备+合同取得成本+合同资产+合同履约成本减值准备+合同资产减值准备+合同履约成本）余额+合同结算明细借方余额",
        "assistantNo": null,
        "equityText": "其他应付款余额",
    }, {
        "asset": "持有待售资产",
        "assetRow": "11",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "持有待售负债",
        "equityRow": "45",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "13",
        "fold": "10",
        "foldFlag": null,
        "assetText": "（持有待售资产减值准备+持有待售资产）余额",
        "equityText": " 持有待售负债",
    }, {
        "asset": "一年内到期的非流动资产",
        "assetRow": "12",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "一年内到期的非流动负债",
        "equityRow": "46",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "14",
        "fold": "10",
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "其他流动资产",
        "assetRow": "13",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "其他流动负债",
        "equityRow": "47",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "15",
        "fold": "10",
        "foldFlag": null,
        "assetText": "（被套期项目+增值税留底税额+待认证进项税额+待抵扣进项税额+套期工具）余额+未交增值税明细借方余额",
        "equityText": "（待转销项税额+受托代销商品款）余额",
    }, {
        "asset": "流动资产合计",
        "assetRow": "14",
        "assetEndBalance": null,
        "assetInitBalance": null,
        "equity": "流动负债合计",
        "equityRow": "48",
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "16",
        "fold": "10",
        "foldFlag": null,
        "assetText": "1到13行合计",
        "equityText": "35到47合计",
    }, {
        "asset": "非流动资产：",
        "assetRow": null,
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "非流动负债：",
        "equityRow": null,
        "equityEndBalance": null,
        "equityInitBalance": null,
        "id": "17",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": null,
    }, {
        "asset": "债权投资",
        "assetRow": "15",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期借款",
        "equityRow": "49",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "18",
        "fold": null,
        "foldFlag": null,
        "assetText": "（债权债权投资+债权投资减值准备）余额",
        "equityText": "长期借款余额",
    }, {
        "asset": "其他债权投资",
        "assetRow": "16",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "应付债券",
        "equityRow": "50",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "19",
        "fold": null,
        "foldFlag": null,
        "assetText": "其他债权投资余额",
        "equityText": "应付债券余额",
    }, {
        "asset": "长期应收款",
        "assetRow": "17",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其中：优先股",
        "equityRow": "51",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "20",
        "fold": null,
        "foldFlag": null,
        "assetText": "长期应收款余额",
        "equityText": "优先股余额",
    }, {
        "asset": "长期股权投资",
        "assetRow": "18",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "永续债",
        "equityRow": "52",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "21",
        "fold": null,
        "foldFlag": null,
        "assetText": "（长期股权投资+长期股权投资减值准备）余额",
        "equityText": "永续债余额",
    }, {
        "asset": "其他权益工具投资",
        "assetRow": "19",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "租赁负债",
        "equityRow": "53",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "22",
        "fold": null,
        "foldFlag": null,
        "assetText": "其他权益工具投资余额",
        "equityText": "租赁负债余额",
    }, {
        "asset": "其他非流动金融资产",
        "assetRow": "20",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "长期应付款",
        "equityRow": "54",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "23",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": "（长期应付款-未确认融资费用+专项应付款）余额",
    }, {
        "asset": "投资性房地产",
        "assetRow": "21",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "预计负债",
        "equityRow": "55",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "24",
        "fold": null,
        "foldFlag": null,
        "assetText": "投资性房地产余额",
        "equityText": "预计负债余额",
    }, {
        "asset": "固定资产",
        "assetRow": "22",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "递延收益",
        "equityRow": "56",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "25",
        "fold": null,
        "foldFlag": null,
        "assetText": "（固定资产+固定资产减值准备+累计折旧）余额",
        "equityText": " 递延收益余额",
    }, {
        "asset": "在建工程",
        "assetRow": "23",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "递延所得税负债",
        "equityRow": "57",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "26",
        "fold": null,
        "foldFlag": null,
        "assetText": "（在建工程+工程物资）余额",
        "equityText": "递延所得税负债余额",
    }, {
        "asset": "生产性生物资产",
        "assetRow": "24",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其他非流动负债",
        "equityRow": "58",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "27",
        "fold": null,
        "foldFlag": null,
        "assetText": "（生产性生物资产+生产性生物资产累计折旧）余额",
        "equityText": null,
    }, {
        "asset": "油气资产",
        "assetRow": "25",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "非流动负债合计",
        "equityRow": "59",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "28",
        "fold": null,
        "foldFlag": null,
        "assetText": "（油气资产+累计折耗）余额",
        "equityText": "49到58行合计",
    }, {
        "asset": "使用权资产",
        "assetRow": "26",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债合计",
        "equityRow": "60",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "29",
        "fold": null,
        "foldFlag": null,
        "assetText": "（使用权资产+使用权资产累计折旧+使用权资产减值准备）余额",
        "equityText": "48+59行合计",
    }, {
        "asset": "无形资产",
        "assetRow": "27",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "所有者权益（或股东权益）：",
        "equityRow": null,
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "30",
        "fold": null,
        "foldFlag": null,
        "assetText": "（无形资产+累计摊销+无形资产减值准备）余额",
        "equityText": null,
    }, {
        "asset": "开发支出",
        "assetRow": "28",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "实收资本（或股本）",
        "equityRow": "61",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "31",
        "fold": null,
        "foldFlag": null,
        "assetText": "研发支出余额",
        "equityText": "实收资本余额",
    }, {
        "asset": "商誉",
        "assetRow": "29",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其他权益工具",
        "equityRow": "62",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "32",
        "fold": null,
        "foldFlag": null,
        "assetText": "商誉余额",
        "equityText": "其他权益工具余额",
    }, {
        "asset": "长期待摊费用",
        "assetRow": "30",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其中：优先股",
        "equityRow": "63",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "33",
        "fold": null,
        "foldFlag": null,
        "assetText": "长期待摊费用余额",
        "equityText": "440101 优先股余额",
    }, {
        "asset": "递延所得税资产",
        "assetRow": "31",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "永续债",
        "equityRow": "64",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "34",
        "fold": null,
        "foldFlag": null,
        "assetText": "递延所得税资产余额",
        "equityText": "440102 永续债",
    }, {
        "asset": "其他非流动资产",
        "assetRow": "32",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "资本公积",
        "equityRow": "65",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "35",
        "fold": null,
        "foldFlag": null,
        "assetText": "（未实现融资收益+待处理财产损溢）余额",
        "equityText": "资本公积余额",
    }, {
        "asset": "非流动资产合计",
        "assetRow": "33",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "减：库存股",
        "equityRow": "66",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "36",
        "fold": null,
        "foldFlag": null,
        "assetText": "15到32行合计",
        "equityText": "库存股余额",
    }, {
        "asset": "",
        "assetRow": null,
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "其他综合收益",
        "equityRow": "67",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "37",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": "其他综合收益余额",
    }, {
        "asset": "",
        "assetRow": null,
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "专项储备",
        "equityRow": "68",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "38",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": "专项储备余额",
    }, {
        "asset": "",
        "assetRow": null,
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "盈余公积",
        "equityRow": "69",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "39",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": "盈余公积余额",
    }, {
        "asset": "",
        "assetRow": null,
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "未分配利润",
        "equityRow": "70",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "40",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": " （本年利润+利润分配）余额",
    }, {
        "asset": "",
        "assetRow": null,
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "所有者权益（或股东权益）合计",
        "equityRow": "71",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "41",
        "fold": null,
        "foldFlag": null,
        "assetText": null,
        "equityText": "61到70行合计",
    }, {
        "asset": "资产总计",
        "assetRow": "34",
        "assetEndBalance": "0",
        "assetInitBalance": "0",
        "equity": "负债和所有者权益（或股东权益）总计",
        "equityRow": "72",
        "equityEndBalance": "0",
        "equityInitBalance": "0",
        "id": "42",
        "fold": null,
        "foldFlag": null,
        "assetText": "+33行合计",
        "equityText": "60+71行合计",
    },
];

const getData = (book: AccountBookList.AccountBook) => {
    switch(book.accountingSystem) {
        case AccountingSystem.thirteenRule: return thirteenRule;
        case AccountingSystem.nineteenRule: return nineteenRule;
        case AccountingSystem.sevenNormal: return sevenRule;
        case AccountingSystem.npo: return npo;
        case AccountingSystem.rural: return rural;
        default: return thirteenRule;
    }
}

const balanceSheetData = {
    thirteenRule,
    sevenRule,
    npo,
    rural,
    nineteenRule,
    getData
};

export default balanceSheetData;
